/* eslint-disable prettier/prettier */
import { store } from '../components/cascader/store';
import config from '../config';
const defaultFetch = () => {
  const { provinceUrl, cityUrl, countyUrl, alias } = config.get().address;
  let provinceres, cityres, countyres;
  provinceres = rt.get(provinceUrl);
  cityres = rt.get(cityUrl);
  countyres = rt.get(countyUrl);
  let { id, name } = alias;
  return Promise.all([provinceres, cityres, countyres]).then(res => {
    let provincelist, citylist, countylist;
    provincelist = res[0].slice();
    citylist = res[1].slice();
    countylist = res[2].slice();
    let provinces = [];
    let cities = {};
    let counties = {};
    provincelist.forEach(province => {
      provinces.push({
        name: province[name],
        id: province[id]
      });
      let cityArry = [];
      citylist.forEach(city => {
        if (city.ParentId === province[id]) {
          cityArry.push({
            name: city[name],
            id: city[id]
          });
        }
        let countyArry = [];
        countylist.forEach(county => {
          if (county.ParentId === city[id]) {
            countyArry.push({
              name: county[name],
              id: county[id]
            });
          }
        });
        counties[city[id]] = countyArry;
      });
      cities[province[id]] = cityArry;
    });

    provinces.forEach(provinceItem => {
      cities[provinceItem.id].forEach(cityItem => {
        cityItem.children = counties[cityItem.id];
      });
      provinceItem.children = cities[provinceItem.id];
    });
    return provinces;
  });
};
export default {
  name: 'AddressPlugin',
  fetch: null,
  install(Vue, opts) {
    Vue.prototype.$address = Vue.address = this;

    const { autoLoad } = config.get().address;
    // 初始化省市县数据 
    autoLoad && this.getAddressData();
  },
  resetFetch(fn = null) {
    this.fetch = fn;
    this.fetch && this.getAddressData();
  },
  getAddressData() {
    let fetchMethod = this.fetch || defaultFetch;
    fetchMethod()
      .then(res => {
        store.updateAddress(res);
      })
      .catch(err => {
        rt.showErrorToast(err);
      });
  }
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/plugins/address-plugin.js